module.exports = __webpack_public_path__ + "img/sld_acdb_dark.5f5b4341.svg";